/* @ngInject */
const metadata = (
  commandeLabels,
  commandeFields,
  commandeButtons
) => {
  const self = {}

  self.favoriteSort = []

  self.badges = []

  self.buttons = [
    commandeButtons.search,
    commandeButtons.edit,
    commandeButtons.delete,
  ]

  self.fields = commandeFields

  return self
}

export default metadata



// WEBPACK FOOTER //
// ./public/javascript/sygem/entities/commande/services/metadata.service.js